import "../step.js";
import "../mixins/oauth_link.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Views ??= {};

AppointmentBooking.Wizard.Views.SignInStep = class SignInStep extends (
  AppointmentBooking.Wizard.Views.Mixins.OAuthLink(AppointmentBooking.Wizard.Views.Step)
) {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.isDisabled = this.isDisabled.bind(this);
    this.beforeShow = this.beforeShow.bind(this);
    this.areRequirementsValid = this.areRequirementsValid.bind(this);
    this.getPageTitle = this.getPageTitle.bind(this);
  }

  autoContinue() {
    return true;
  } // We want to automatically move to the next step once the requirements are met because the step contents serves as navigation

  initialize() {
    super.initialize(...arguments);
    return this.listenTo(this.model, "change:appointment_slot", this.render);
  }

  isDisabled() {
    return !this.model.get("visit_type")?.allow_mychart_login;
  }

  beforeShow() {
    // Every time the user sees this page they must choose how to log in
    this.model.set({ login_type: null, mychart_login_error: null });
    return this.model.resetPatient();
  }

  areRequirementsValid() {
    return this.model.get("login_type");
  }

  getPageTitle() {
    return `${this.I18n().sign_in.page_title} - ${this.model.get("appointment_slot").visit_type_name}`;
  }
};
AppointmentBooking.Wizard.Views.SignInStep.prototype.template = "step/sign_in";
AppointmentBooking.Wizard.Views.SignInStep.prototype.className = "appointment-booking-wizard-sign-in-step";
AppointmentBooking.Wizard.Views.SignInStep.prototype.name = "Sign In";
